// This is a subset of `PolarisSpacing` and `PolarisSpacingValue` types.
// Uses "base" by default.
let TopBarSpacingValue = /*#__PURE__*/function (TopBarSpacingValue) {
  TopBarSpacingValue["Base"] = "base";
  TopBarSpacingValue["None"] = "none";
  TopBarSpacingValue["Tight"] = "tight";
  TopBarSpacingValue["Loose"] = "loose";
  TopBarSpacingValue["BaseTight"] = "base-tight";
  TopBarSpacingValue["ExtraTight"] = "extra-tight";
  return TopBarSpacingValue;
}({});
let TopBarPaddedValue = /*#__PURE__*/function (TopBarPaddedValue) {
  TopBarPaddedValue["Both"] = "both";
  TopBarPaddedValue["Left"] = "left";
  TopBarPaddedValue["Right"] = "right";
  return TopBarPaddedValue;
}({});

export { TopBarPaddedValue, TopBarSpacingValue };
